import {
	EmailTemplateTypes,
	IEmailTemplateEditingForm,
	IEmailTemplateParams,
} from 'modules/admin-panel/pages/settings/models';
import { prepareHtmlToSend, preparePlaintext } from './emailTextEditing';

interface IMapParams {
	data: IEmailTemplateEditingForm;
	templateType: EmailTemplateTypes;
	surveyName: string;
	editorText: string;
	buttonColor: string;
}

export const mapEmailTemplateData = ({
	data,
	templateType,
	surveyName,
	editorText,
	buttonColor,
}: IMapParams): IEmailTemplateParams => {
	const {
		from,
		subject,
		useClientLogo,
		btnColorType,
		useFooter,
		footerText,
		useUnsubscribe,
		useVoxxifyLogo,
	} = data;

	return {
		type: templateType,
		emailHeaders: {
			from: from.trim(),
			subject: subject.trim(),
		},
		paramsHtml: {
			useClientLogo,
			content: {
				surveyName,
				emailText: prepareHtmlToSend(editorText),
				button: {
					color: buttonColor,
					colorType: btnColorType,
				},
			},
			useFooter,
			footer: {
				footerText,
				useUnsubscribe,
				useVoxxifyLogo,
			},
		},
		paramsPlaintext: {
			content: {
				emailText: preparePlaintext(editorText),
			},
			useFooter,
			footer: {
				footerText,
				useUnsubscribe,
			},
		},
	};
};
